"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiButtonOverrides = void 0;
var colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");
var createMuiButtonOverrides = function (_a) {
    var palette = _a.palette, spacing = _a.spacing, transitions = _a.transitions, typography = _a.typography;
    return ({
        root: {
            minWidth: spacing(8),
            minHeight: spacing(8),
            padding: spacing(1, 4),
            textAlign: "center",
            transition: transitions.create(["background-color", "border-color", "opacity", "color"], { duration: transitions.duration.short }),
            "&:hover": {
                backgroundColor: undefined,
            },
            "&$disabled": {
                color: undefined,
                opacity: palette.action.disabledOpacity,
            },
        },
        focusVisible: {
            "&$contained, &$text": {
                boxShadow: "inset 0 0 0 1px " + palette.text.primary,
            },
        },
        startIcon: {
            marginRight: spacing(2),
            marginLeft: -2,
        },
        endIcon: {
            marginRight: -2,
            marginLeft: spacing(2),
        },
        contained: {
            "&$disabled": {
                color: undefined,
                backgroundColor: undefined,
            },
        },
        containedPrimary: {
            "&:hover": {
                backgroundColor: colorManipulator_1.lighten(palette.primary.main, palette.action.hoverOpacity),
            },
            "&:active": {
                backgroundColor: colorManipulator_1.lighten(palette.primary.main, palette.action.activatedOpacity),
            },
            "&$focusVisible": {
                backgroundColor: colorManipulator_1.lighten(palette.primary.main, palette.action.focusOpacity),
            },
        },
        containedSecondary: {
            "&:hover": {
                backgroundColor: colorManipulator_1.lighten(palette.secondary.main, palette.action.hoverOpacity),
            },
            "&:active": {
                backgroundColor: colorManipulator_1.lighten(palette.secondary.main, palette.action.activatedOpacity),
            },
            "&$focusVisible": {
                backgroundColor: colorManipulator_1.lighten(palette.secondary.main, palette.action.focusOpacity),
            },
        },
        outlined: {
            // Default, minus border thickness
            padding: spacing(1) - 1 + "px " + (spacing(4) - 1) + "px",
            "&$disabled": {
                border: undefined,
            },
        },
        outlinedPrimary: {
            border: undefined,
            borderColor: palette.primary.main,
            color: palette.text.primary,
            "&:hover": {
                border: undefined,
                backgroundColor: colorManipulator_1.alpha(palette.primary.main, palette.action.hoverOpacity),
            },
            "&:active": {
                backgroundColor: colorManipulator_1.alpha(palette.primary.main, palette.action.selectedOpacity),
            },
            "&&$focusVisible": {
                borderColor: undefined,
                backgroundColor: colorManipulator_1.alpha(palette.primary.main, palette.action.focusOpacity),
            },
        },
        outlinedSecondary: {
            border: undefined,
            borderColor: palette.dividerStrong,
            color: palette.text.primary,
            "&:hover": {
                border: undefined,
                color: palette.text.primary,
                backgroundColor: palette.action.hover,
            },
            "&$focusVisible": {
                color: palette.text.primary,
                borderColor: palette.text.primary,
                backgroundColor: palette.action.focus,
            },
            "&:active": {
                color: palette.text.primary,
                backgroundColor: palette.action.active,
            },
            "&$disabled": {
                border: undefined,
            },
        },
        text: {
            padding: spacing(1, 2),
        },
        textPrimary: {
            color: palette.text.primary,
            "&:hover": {
                backgroundColor: palette.action.hover,
            },
            "&$focusVisible": {
                backgroundColor: palette.action.focus,
            },
            "&:active": {
                backgroundColor: palette.action.active,
            },
        },
        iconSizeMedium: {
            "&> *:first-child": {
                fontSize: 24,
            },
        },
        iconSizeLarge: {
            "&> *:first-child": {
                fontSize: 24,
            },
        },
        sizeLarge: {
            minHeight: spacing(12),
        },
        containedSizeLarge: {
            padding: spacing(3, 6),
            fontSize: undefined,
        },
        textSizeLarge: {
            padding: spacing(3),
            fontSize: undefined,
        },
        outlinedSizeLarge: {
            // Default, minus border thickness
            padding: spacing(3) - 1 + "px " + (spacing(6) - 1) + "px",
            fontSize: undefined,
        },
        // Size small will be undocumented now, but we're keeping support
        sizeSmall: {
            minHeight: spacing(6),
            padding: "3px " + spacing(2) + "px",
            "&&": {
                flexGrow: 0,
                fontSize: typography.pxToRem(9),
            },
        },
        outlinedSizeSmall: {
            // Default, minus border thickness
            padding: "2px " + (spacing(2) - 1) + "px",
            fontSize: undefined,
        },
        // Unset other variant specific changes
        containedSizeSmall: { padding: undefined, fontSize: undefined },
        textSizeSmall: { padding: undefined, fontSize: undefined },
    });
};
exports.createMuiButtonOverrides = createMuiButtonOverrides;
//# sourceMappingURL=MuiButton.js.map